import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./StoryCard";
import laptopImg from "../../Assets/robot_birds.jpg";




function Story() {

  return (
    <Container fluid className="about-section story-page">
      <Particle />
      <Container className="story-container">
        <header className="story-hero">
          <h1 className="story-hero-title">
            Our <strong className="purple">Story</strong>
          </h1>
          <p className="story-hero-lead">
            A journey of truth-seeking, transformation, and service.
          </p>
        </header>

        <Row className="story-top" style={{ justifyContent: "center" }}>
          <Col md={7} className="story-left">
            <Aboutcard />
          </Col>

          <Col md={5} className="story-right">
            <div className="policy-card story-image-card">
              <img src={laptopImg} alt="Simorgh inspired imagery" className="story-image" />
            </div>
          </Col>
        </Row>

        <h2 className="story-section-heading">
          Our <strong className="purple">Journey</strong>
        </h2>

        <p className="story-section-lead">
          A concise timeline of growth—from foundation to scaling impact.
        </p>

        <Techstack />
      </Container>
    </Container>
  );
}

export default Story;
